import { moment } from '@hotjar/insights-common/lib/moment';

import type { AbsoluteDateRange, DateRange } from './DateRangeFilterType';
import { DATE_RANGE_TYPE } from './DateRangeFilterType';

export enum ValidationErrorEnum {
  SELECT_ONE_OPTION = 'Select one option',
  INVALID_CUSTOM_DATE = 'Invalid custom date',
  INVALID_CUSTOM_FROM_DATE = 'Invalid custom date ', // <= Hackish: I add a space to distinguish the string from INVALID_CUSTOM_DATE
  INVALID_CUSTOM_TO_DATE = 'Invalid custom date  ', // <= Hackish: I add a space to distinguish the string from INVALID_CUSTOM_DATE and INVALID_CUSTOM_FROM_DATE
  FROM_DATE_BEFORE_MIN_DATE = 'from date is before the min date',
  TO_DATE_BEFORE_MIN_DATE = 'to date is before the min date',
}

export function validateValue(
  value?: DateRange,
  customDateRange?: AbsoluteDateRange,
  preventDatesBefore?: Date,
): ValidationErrorEnum | undefined {
  if (!value) {
    return ValidationErrorEnum.SELECT_ONE_OPTION;
  }
  if (value.type === DATE_RANGE_TYPE.ABSOLUTE) {
    if (!customDateRange) {
      return ValidationErrorEnum.INVALID_CUSTOM_DATE;
    }
    if (customDateRange.from == null) {
      return ValidationErrorEnum.INVALID_CUSTOM_FROM_DATE;
    }
    if (customDateRange.to == null) {
      return ValidationErrorEnum.INVALID_CUSTOM_TO_DATE;
    }
    if (preventDatesBefore) {
      if (moment(customDateRange.from).isBefore(preventDatesBefore, 'day')) {
        return ValidationErrorEnum.FROM_DATE_BEFORE_MIN_DATE;
      }
      if (moment(customDateRange.to).isBefore(preventDatesBefore, 'day')) {
        return ValidationErrorEnum.TO_DATE_BEFORE_MIN_DATE;
      }
    }
  }
  return undefined;
}
